<template>
  <div class="contentA">
    <div class="content-top">
      <span :class="type == 1? 'active' : ''" style="margin-right: 26px" @click="changeType(1)">教育统计</span>
      <span :class="type == 2? 'active' : ''" @click="changeType(2)">视频库</span>
    </div>
    <div class="content-box">
      <eduction-count v-if="type == 1"></eduction-count>
      <video-library v-else-if="type == 2"></video-library>
    </div>
  </div>
</template>

<script>
import eductionCount from './components/eductionCount.vue'
import videoLibrary from './components/videoLibrary.vue'
  export default {
    components: {
      eductionCount,
      videoLibrary
    },
    data() {
      return {
        type: 1
      }
    },
    created() {
      
    },
    methods: {
      changeType(type){
        this.type = type
      }
    },
  }
</script>

<style scoped>
.contentA{
  padding: 1vh 24px 1vh 8px;
  overflow: hidden;
  height: 100%;
}
.content-top{
  padding: 0 18px;
  height: 56px;
  border-radius: 6px;
  background: #FFFFFF;
  text-align: left;
  line-height: 56px;
  margin-bottom: 8px;
}
.content-top > span{
  font-size: 16px;
  color: #666;
  padding: 18px 0;
  cursor: pointer;
}
.active{
  border-bottom: 2px solid #0D3A95;
}
.content-box{
  height: calc(100% - 1vh - 54px);
  overflow: auto;
}
</style>